module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_tiempo_1983.dab7b4b8.jpg";